import Impact from './Impact';

const Configuration = {
  maxScore: new Impact(2000, 20, 20),
  passGoReward: new Impact(100, 0, 0),
  requiredEventsToWin: 1
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/models/Configuration.js